import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled } from '../../../foundation';
var _StyledSvg = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.cloneElement(children, __assign({ ref: ref }, props));
});
export var StyledSvg = styled(_StyledSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1em;\n  height: 1em;\n  stroke-width: 0;\n  stroke: currentColor;\n  fill: currentColor;\n  pointer-events: none;\n"], ["\n  width: 1em;\n  height: 1em;\n  stroke-width: 0;\n  stroke: currentColor;\n  fill: currentColor;\n  pointer-events: none;\n"])));
var templateObject_1;
